var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-100"
  }, [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": true
    }
  }), _vm.$permissions.hasAggregatorRole() ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("Select company")))]), _c('div', {
    staticClass: "search-form input-group company-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "search form-control px-2",
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": _vm.$t('Search'),
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }
    }
  }), _vm.query.length > 0 ? _c('button', {
    staticClass: "btn bg-transparent",
    staticStyle: {
      "margin-left": "-40px",
      "z-index": "100"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.query = '';
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times text-primary"
  })]) : _vm._e()])])])]), _c('div', {
    staticClass: "row"
  }, [_vm._l(_vm.filteredCompanies, function (company) {
    return _c('div', {
      key: company.id,
      staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
    }, [_c('div', {
      staticClass: "card card-company",
      class: {
        active: company.id === _vm.selectedCompanyId
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.onCompanyClick(company);
        }
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('span', {
      staticClass: "fas fa-landmark fa-xl mr-4"
    }), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(company.name))])]), _c('div', {
      staticClass: "card-body text-center"
    }, [_c('span', {
      staticClass: "fas fa-home mr-2"
    }), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(company.assignedControllersCount))])])])]);
  }), _vm.$permissions.hasSuperAdminRole() ? _c('div', {
    staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4",
    on: {
      "click": _vm.onNewCompanyClick
    }
  }, [_c('div', {
    staticClass: "card text-center card-company",
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    staticClass: "py-4"
  }, [_c('span', {
    staticClass: "text-primary fa fa-solid fa-xl fa-plus mr-2"
  }), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.$t("Add new")))])])])]) : _vm._e()], 2)]) : _vm._e(), _vm.showNewCompanyModal ? _c('Modal', {
    staticClass: "new-company-modal",
    on: {
      "close": function ($event) {
        _vm.showNewCompanyModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('h4', [_vm._v("Create new company")]), _c('button', {
          staticClass: "btn-close",
          on: {
            "click": function ($event) {
              _vm.showNewCompanyModal = false;
            }
          }
        }, [_vm._v("X")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_c('CreateCompanyForm', {
          on: {
            "reset": function ($event) {
              _vm.showNewCompanyModal = false;
            },
            "created": _vm.onCompanyCreated
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return undefined;
      },
      proxy: true
    }], null, false, 3555348098)
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }